var exports = {
  "n": "xcc377c0b--17de06--row",
};

module.exports = exports;
